/* ============================================================
   ACID WASHED — theme scripts
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var ACID = window.ACID || {};
  var routes = ACID.routes || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (ACID.forceMotion) reduceMotion = false;

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents) {
    var format = ACID.moneyFormat || '${{amount}}';
    function num(value, precision, thousands, decimal) {
      if (isNaN(value) || value == null) return '0';
      value = (value / 100.0).toFixed(precision);
      var parts = value.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var tail = parts[1] ? decimal + parts[1] : '';
      return head + tail;
    }
    var out = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount': out = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': out = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = num(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = num(cents, 2, ' ', '.'); break;
      default: out = num(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  var scrollLock = {
    count: 0,
    lock: function () {
      if (this.count === 0) {
        this.y = window.scrollY;
        document.body.classList.add('is-locked');
      }
      this.count++;
    },
    unlock: function () {
      this.count = Math.max(0, this.count - 1);
      if (this.count === 0) document.body.classList.remove('is-locked');
    }
  };

  function trapFocus(container) {
    var selectors = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var nodes = $$(selectors, container).filter(function (el) { return el.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ---------- overlay controller (menu, cart, search) ---------- */

  var Overlay = {
    active: null,
    releaseFocus: null,
    opener: null,
    scrim: null,

    init: function () {
      this.scrim = $('[data-scrim]');
      var self = this;
      if (this.scrim) {
        this.scrim.addEventListener('click', function () { self.close(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.active) self.close();
      });
    },

    open: function (el, opener) {
      if (!el) return;
      if (this.active && this.active !== el) this.close(true);
      this.active = el;
      this.opener = opener || document.activeElement;
      el.hidden = false;
      // force a reflow so the closed state is the transition's starting point
      void el.offsetWidth;
      el.setAttribute('aria-hidden', 'false');
      el.classList.add('is-active');
      if (this.scrim) {
        this.scrim.hidden = false;
        void this.scrim.offsetWidth;
        this.scrim.classList.add('is-active');
      }
      scrollLock.lock();
      this.releaseFocus = trapFocus(el);
      var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector('button, a[href], input');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 120);
      document.dispatchEvent(new CustomEvent('acid:overlay:open', { detail: { element: el } }));
    },

    close: function (silent) {
      var el = this.active;
      if (!el) return;
      this.active = null;
      el.setAttribute('aria-hidden', 'true');
      el.classList.remove('is-active');
      if (this.releaseFocus) { this.releaseFocus(); this.releaseFocus = null; }
      if (this.scrim) this.scrim.classList.remove('is-active');
      scrollLock.unlock();
      var opener = this.opener;
      var scrim = this.scrim;
      window.setTimeout(function () {
        if (!Overlay.active) {
          el.hidden = true;
          if (scrim) scrim.hidden = true;
        }
      }, reduceMotion ? 10 : 500);
      if (!silent && opener && typeof opener.focus === 'function') opener.focus();
    }
  };

  /* ---------- header ---------- */

  function initHeader() {
    var wrap = $('[data-header-wrap]');
    if (!wrap) return;
    var header = $('[data-header]', wrap);

    function setHeight() {
      var h = header ? header.offsetHeight : 72;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    setHeight();
    window.addEventListener('resize', debounce(setHeight, 150));

    var threshold = 40;
    function onScroll() {
      wrap.classList.toggle('is-scrolled', window.scrollY > threshold);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- drawers wiring ---------- */

  function initTriggers() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-overlay-open]');
      if (openBtn) {
        var target = document.querySelector(openBtn.getAttribute('data-overlay-open'));
        if (target) { e.preventDefault(); Overlay.open(target, openBtn); }
        return;
      }
      if (e.target.closest('[data-overlay-close]')) {
        e.preventDefault();
        Overlay.close();
      }
    });
  }

  /* ---------- cart ---------- */

  var Cart = {
    drawer: function () { return $('#CartDrawer'); },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        var span = el.querySelector('span');
        if (span) span.textContent = count;
        else el.textContent = count;
        el.hidden = !count;
      });
      $$('[data-cart-count-text]').forEach(function (el) { el.textContent = count; });
    },

    sectionsToRender: function () {
      var ids = [];
      if (document.getElementById('shopify-section-cart-drawer')) ids.push('cart-drawer');
      var main = $('[data-cart-section]');
      if (main) ids.push(main.getAttribute('data-cart-section'));
      return ids.join(',');
    },

    render: function (sections) {
      if (!sections) return;
      var drawer = this.drawer();
      var wasOpen = !!drawer && drawer.getAttribute('aria-hidden') === 'false';
      Object.keys(sections).forEach(function (id) {
        var target = document.getElementById('shopify-section-' + id);
        if (!target) return;
        var parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        var fresh = parsed.getElementById('shopify-section-' + id);
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
      var source = $('[data-cart-count-source]');
      if (source) Cart.updateCount(parseInt(source.getAttribute('data-cart-count-source'), 10) || 0);
      if (wasOpen && drawer) {
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-active');
      }
      document.dispatchEvent(new CustomEvent('acid:cart:updated'));
    },

    open: function (opener) {
      var drawer = this.drawer();
      if (drawer) Overlay.open(drawer, opener);
    },

    add: function (formDataOrItems, opener) {
      var body;
      var headers = { 'Accept': 'application/json' };
      var sections = this.sectionsToRender();
      if (formDataOrItems instanceof FormData) {
        if (sections) {
          formDataOrItems.append('sections', sections);
          formDataOrItems.append('sections_url', window.location.pathname);
        }
        body = formDataOrItems;
      } else {
        headers['Content-Type'] = 'application/json';
        var payload = { items: formDataOrItems };
        if (sections) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }
        body = JSON.stringify(payload);
      }
      return fetch(routes.cart_add_url + '.js', { method: 'POST', headers: headers, body: body })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          Cart.render(data.sections);
          if (ACID.cartDrawerEnabled) Cart.open(opener);
          else window.location.href = routes.cart_url;
          return data;
        });
    },

    change: function (payload) {
      var sections = this.sectionsToRender();
      if (sections) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }
      var drawer = this.drawer();
      if (drawer) drawer.classList.add('is-loading');
      return fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.render(cart.sections);
          Cart.updateCount(cart.item_count);
          if (drawer) drawer.classList.remove('is-loading');
          return cart;
        })
        .catch(function (err) {
          if (drawer) drawer.classList.remove('is-loading');
          throw err;
        });
    }
  };

  function initCartEvents() {
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        Cart.change({ line: parseInt(remove.getAttribute('data-line'), 10), quantity: 0 });
        return;
      }
      var step = e.target.closest('[data-cart-qty-step]');
      if (step) {
        e.preventDefault();
        var input = step.parentElement.querySelector('input');
        var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-cart-qty-step'), 10);
        if (next < 0) next = 0;
        input.value = next;
        Cart.change({ line: parseInt(input.getAttribute('data-line'), 10), quantity: next });
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      Cart.change({ line: parseInt(input.getAttribute('data-line'), 10), quantity: parseInt(input.value, 10) || 0 });
    });

    var noteSave = debounce(function (value) {
      fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 500);
    document.addEventListener('input', function (e) {
      if (e.target.closest('[data-cart-note]')) noteSave(e.target.value);
    });
  }

  /* ---------- product form ---------- */

  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form || !ACID.cartDrawerEnabled) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = '...'; }
      Cart.add(new FormData(form), btn)
        .catch(function (err) {
          var errorEl = form.querySelector('[data-form-error]');
          if (errorEl) { errorEl.textContent = err.message || ACID.strings.cartError; errorEl.hidden = false; }
        })
        .then(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = original; }
        });
    });

    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var input = step.parentElement.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- variant picker ---------- */

  function initVariantPickers(scope) {
    $$('[data-variant-picker]', scope || document).forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      var sectionId = picker.getAttribute('data-section');
      var dataEl = document.getElementById('VariantData-' + sectionId);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var lowStock = parseInt(picker.getAttribute('data-low-stock') || '0', 10);
      var root = picker.closest('[data-product-root]') || document;

      function currentOptions() {
        return $$('fieldset', picker).map(function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function markAvailability(selected) {
        $$('fieldset', picker).forEach(function (fs, index) {
          $$('input', fs).forEach(function (input) {
            var probe = selected.slice();
            probe[index] = input.value;
            var match = variants.filter(function (v) {
              for (var i = 0; i < probe.length; i++) {
                if (i !== index && probe[i] !== null && v.options[i] !== probe[i]) return false;
              }
              return v.options[index] === input.value;
            });
            var available = match.some(function (v) { return v.available; });
            var exists = match.length > 0;
            var label = input.nextElementSibling;
            if (label) label.classList.toggle('option__swatch--unavailable', !available || !exists);
            input.disabled = false;
          });
        });
      }

      function update() {
        var selected = currentOptions();
        var variant = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        markAvailability(selected);

        $$('[data-option-selected]', picker).forEach(function (el) {
          var i = parseInt(el.getAttribute('data-option-selected'), 10);
          el.textContent = selected[i] || '';
        });

        var idInput = $('[data-variant-id]', root);
        var addBtn = $('[data-add-button]', root);
        var priceEl = $('[data-price-wrap]', root);
        var stockEl = $('[data-stock]', root);
        var stickyPrice = $('[data-sticky-price]', root);

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = ACID.strings.unavailable; }
          if (stockEl) stockEl.hidden = true;
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) {
          var html = '<span class="price">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        if (addBtn) {
          addBtn.disabled = !variant.available;
          // Wortlaut kommt vom Server ueber data-Attribute, nicht aus
          // der globalen Zeichenkette: im Vorverkauf heisst der Knopf
          // "BALD VERFUEGBAR" und nicht "AUSVERKAUFT". Die globalen
          // Strings bleiben als Rueckfall, falls die Attribute fehlen.
          var textAn = addBtn.getAttribute('data-text-in') || ACID.strings.addToCart;
          var textAus = addBtn.getAttribute('data-text-out') || ACID.strings.soldOut;
          addBtn.textContent = variant.available ? textAn : textAus;
        }

        // Vormerken: die gewaehlte Groesse wandert als Kundentag mit, damit
        // sichtbar wird, welche Groessen gefragt sind, BEVOR bestellt wird.
        // Stuessy sammelt an dieser Stelle nur die Mail - die Groesse ist der
        // Teil, der hier zusaetzlich etwas wert ist.
        var tagFeld = $('[data-notify-tags]', root);
        if (tagFeld) {
          var basis = tagFeld.getAttribute('data-basis') || 'vormerkung';
          // title kam frueher nicht im Varianten-JSON vor; options ist
          // der Rueckfallweg, falls das Feld einmal wieder fehlt.
          var groesse = (variant.title || (variant.options || []).join(' / ') || '').trim();
          tagFeld.value = groesse ? basis + ',groesse-' + groesse : basis;
          var zeile = $('[data-notify-size]', root);
          if (zeile) {
            if (groesse) {
              zeile.textContent = 'Deine Größe: ' + groesse;
              zeile.hidden = false;
            } else {
              zeile.hidden = true;
            }
          }
        }

        if (stockEl) {
          stockEl.hidden = false;
          stockEl.classList.remove('product__stock--low', 'product__stock--out');
          if (!variant.available) {
            stockEl.classList.add('product__stock--out');
            stockEl.textContent = stockEl.getAttribute('data-text-out');
          } else if (variant.managed && lowStock > 0 && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStock) {
            stockEl.classList.add('product__stock--low');
            stockEl.textContent = (stockEl.getAttribute('data-text-low') || '').replace('{{ count }}', variant.inventory_quantity);
          } else {
            stockEl.textContent = stockEl.getAttribute('data-text-in');
          }
        }

        if (variant.media_id) {
          var media = $('[data-media-id="' + variant.media_id + '"]', root);
          if (media && window.innerWidth > 989) {
            media.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        }

        if (history.replaceState && picker.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ---------- quick add ---------- */

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-quick-toggle]');
      if (toggle) {
        e.preventDefault();
        var wrap = toggle.closest('[data-quick]');
        var variantId = toggle.getAttribute('data-variant-id');
        if (variantId) {
          toggle.setAttribute('aria-disabled', 'true');
          Cart.add([{ id: parseInt(variantId, 10), quantity: 1 }], toggle)
            .catch(function () {})
            .then(function () { toggle.removeAttribute('aria-disabled'); });
        } else if (wrap) {
          $$('[data-quick].is-open').forEach(function (el) { if (el !== wrap) el.classList.remove('is-open'); });
          wrap.classList.add('is-open');
        }
        return;
      }
      var variantBtn = e.target.closest('[data-quick-variant]');
      if (variantBtn) {
        e.preventDefault();
        variantBtn.setAttribute('aria-disabled', 'true');
        Cart.add([{ id: parseInt(variantBtn.getAttribute('data-variant-id'), 10), quantity: 1 }], variantBtn)
          .catch(function () {})
          .then(function () {
            variantBtn.removeAttribute('aria-disabled');
            var wrap = variantBtn.closest('[data-quick]');
            if (wrap) wrap.classList.remove('is-open');
          });
        return;
      }
      if (!e.target.closest('[data-quick]')) {
        $$('[data-quick].is-open').forEach(function (el) { el.classList.remove('is-open'); });
      }
    });
  }

  /* ---------- scroll reveal ---------- */

  function initReveal() {
    var items = $$('.reveal, .reveal-img, [data-reveal-group]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { observer.observe(el); });

    // Zweiter Weg, unabhaengig vom Observer.
    //
    // Wenn der Observer aus irgendeinem Grund nicht ausloest, bleibt der Inhalt
    // sonst DAUERHAFT unsichtbar - das ist das schlechteste denkbare Verhalten
    // fuer eine reine Verschoenerung. Deshalb prueft ein gedrosselter
    // Scroll-Horcher zusaetzlich selbst nach, was im Blickfeld steht.
    var offen = items.slice();
    var zuletzt = 0;

    function nachsehen() {
      zuletzt = Date.now();
      var hoehe = window.innerHeight || document.documentElement.clientHeight;
      offen = offen.filter(function (el) {
        if (el.classList.contains('is-visible')) return false;
        var r = el.getBoundingClientRect();
        if (r.top < hoehe && r.bottom > 0) {
          el.classList.add('is-visible');
          observer.unobserve(el);
          return false;
        }
        return true;
      });
      if (!offen.length) {
        window.removeEventListener('scroll', anstossen);
        window.removeEventListener('resize', anstossen);
      }
    }

    // Bewusst ueber die Uhr gedrosselt und NICHT ueber requestAnimationFrame:
    // in einem Hintergrund-Tab laeuft kein Frame, und dann haengt der Rueckfallweg.
    function anstossen() {
      if (Date.now() - zuletzt < 120) return;
      nachsehen();
    }

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
    window.addEventListener('load', nachsehen);
    nachsehen();
  }

  /* ---------- hero parallax ---------- */

  function initParallax() {
    var heroes = $$('[data-parallax]');
    if (!heroes.length || reduceMotion) return;
    var ticking = false;
    function frame() {
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var shift = Math.round(rect.top * -0.12);
        hero.style.setProperty('--parallax', shift + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(frame); ticking = true; }
    }, { passive: true });
    frame();
  }

  /* ---------- sticky add to cart ---------- */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;
    var anchor = $('[data-sticky-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    function pruefen() {
      // Leiste zeigen, sobald der Kaufknopf nach oben aus dem Bild ist.
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().top < 0);
    }

    // Der Beobachter ist der sparsame Weg, aber in einem Tab, der nicht
    // gezeichnet wird, pausiert er. Deshalb rechnet ein Scroll-Zuhoerer
    // zusaetzlich selbst nach - gedrosselt ueber Date.now(), damit er bei
    // schnellem Scrollen nicht bei jedem Pixel arbeitet.
    var observer = new IntersectionObserver(pruefen, { threshold: 0 });
    observer.observe(anchor);

    var zuletzt = 0;
    window.addEventListener('scroll', function () {
      var jetzt = Date.now();
      if (jetzt - zuletzt < 80) return;
      zuletzt = jetzt;
      pruefen();
    }, { passive: true });
    pruefen();

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sticky-add]');
      if (!btn) return;
      var form = $('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- testimonials carousel ---------- */

  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      var track = $('[data-carousel-track]', root);
      var slides = $$('[data-carousel-slide]', root);
      var dots = $$('[data-carousel-dot]', root);
      if (!track || slides.length < 2) return;
      var index = 0;
      var autoplay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
      var timer;

      function go(next) {
        index = (next + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * index) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      }

      function restart() {
        if (!autoplay || reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { go(index + 1); }, autoplay);
      }

      root.addEventListener('click', function (e) {
        var prev = e.target.closest('[data-carousel-prev]');
        var next = e.target.closest('[data-carousel-next]');
        var dot = e.target.closest('[data-carousel-dot]');
        if (prev) go(index - 1);
        if (next) go(index + 1);
        if (dot) go(dots.indexOf(dot));
        if (prev || next || dot) restart();
      });

      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) { go(dx < 0 ? index + 1 : index - 1); restart(); }
        startX = null;
      });

      go(0);
      restart();
    });
  }

  /* ---------- lightbox ---------- */

  function initLightbox() {
    var images = [];
    var node = null;
    var current = 0;

    function build() {
      node = document.createElement('div');
      node.className = 'lightbox';
      node.setAttribute('role', 'dialog');
      node.setAttribute('aria-modal', 'true');
      node.innerHTML =
        '<button class="lightbox__close" data-lb-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<button class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M15 4l-8 8 8 8"/></svg></button>' +
        '<img alt="">' +
        '<button class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M9 4l8 8-8 8"/></svg></button>';
      document.body.appendChild(node);
      node.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]') || e.target === node) close();
        if (e.target.closest('[data-lb-prev]')) show(current - 1);
        if (e.target.closest('[data-lb-next]')) show(current + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (!node || !node.classList.contains('is-active')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    function show(i) {
      current = (i + images.length) % images.length;
      node.querySelector('img').src = images[current];
    }

    function close() {
      node.classList.remove('is-active');
      scrollLock.unlock();
      setTimeout(function () { if (node) node.style.display = 'none'; }, reduceMotion ? 10 : 400);
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox]');
      if (!trigger) return;
      e.preventDefault();
      var group = trigger.closest('[data-lightbox-group]') || document;
      var triggers = $$('[data-lightbox]', group);
      images = triggers.map(function (t) { return t.getAttribute('data-lightbox'); });
      if (!node) build();
      node.style.display = 'grid';
      void node.offsetWidth;
      node.classList.add('is-active');
      scrollLock.lock();
      show(triggers.indexOf(trigger));
    });
  }

  /* ---------- rotating headline words ---------- */

  function initRotators() {
    $$('[data-rotator]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var words = $$('[data-rotator-word]', root);
      if (words.length < 2 || reduceMotion) return;
      var index = 0;
      window.setInterval(function () {
        var current = words[index];
        index = (index + 1) % words.length;
        var next = words[index];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.add('is-active');
        window.setTimeout(function () { current.classList.remove('is-leaving'); }, 600);
      }, 2800);
    });
  }

  /* ---------- horizontal product slider ---------- */

  function initSliders() {
    $$('[data-slider]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var track = $('[data-slider-track]', root);
      if (!track) return;
      var prev = $('[data-slider-prev]', root);
      var next = $('[data-slider-next]', root);

      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        root.classList.toggle('is-static', max <= 0);
      }

      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', debounce(sync, 80), { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(debounce(sync, 80)).observe(track);
      } else {
        window.addEventListener('resize', debounce(sync, 150));
      }
      window.addEventListener('load', sync);
      window.requestAnimationFrame(sync);
      sync();
    });
  }

  /* ---------- fit-to-width wordmark ---------- */

  function fitText(el) {
    var inner = el.querySelector('[data-fit-text-inner]');
    if (!inner) return;
    var cs = window.getComputedStyle(el);
    var available = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (available <= 0) return;
    el.style.fontSize = '100px';
    var width = inner.getBoundingClientRect().width;
    if (!width) { el.style.fontSize = ''; return; }
    var size = Math.floor((available / width) * 100);
    el.style.fontSize = Math.max(24, size) + 'px';
  }

  function initFitText() {
    var nodes = $$('[data-fit-text]');
    if (!nodes.length) return;
    function run() { nodes.forEach(fitText); }
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(debounce(run, 100));
      nodes.forEach(function (node) { observer.observe(node); });
    } else {
      window.addEventListener('resize', debounce(run, 150));
    }
    window.requestAnimationFrame(run);
    window.addEventListener('load', run);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  }

  /* ---------- predictive search ---------- */


  /* ---------- Produktkarte: Rueckansicht am Handy ----------
     Desktop hat Hover. Touch-Geraete haben das nicht, deshalb hier:
     Finger auf die Karte = Rueckseite, Finger weg = wieder Vorderseite.
     Es wird nichts abgefangen - ein kurzer Tipp oeffnet weiter das Produkt. */

  function initCardPeek() {
    if (matchMedia('(hover: hover)').matches) return;

    function an(e) {
      var karte = e.target.closest('.card--has-second');
      if (karte) karte.classList.add('is-peek');
    }
    function aus(e) {
      var karte = e.target.closest('.card--has-second');
      if (karte) karte.classList.remove('is-peek');
      else $$('.card.is-peek').forEach(function (k) { k.classList.remove('is-peek'); });
    }

    document.addEventListener('touchstart', an, { passive: true });
    document.addEventListener('touchend', aus, { passive: true });
    document.addEventListener('touchcancel', aus, { passive: true });
  }

  /* ---------- mehrere Ansichten je Produktkarte ---------- */

  function initCardAngles() {
    var karten = $$('.card--angles');
    if (!karten.length) return;
    var hatMaus = matchMedia('(hover: hover)').matches;

    karten.forEach(function (karte) {
      var ansichten = $$('.card__img--angle', karte);
      var punkte = $$('.card__angle-dot', karte);
      if (!ansichten.length) return;
      var anzahl = ansichten.length + 1;   // das erste Bild zaehlt mit
      var jetzt = -1;

      function zeige(i) {
        if (i === jetzt) return;
        jetzt = i;
        karte.classList.toggle('is-angled', i > 0);
        ansichten.forEach(function (bild, n) {
          bild.classList.toggle('is-active', n === i - 1);
        });
        punkte.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
      }

      if (hatMaus) {
        // Die Mausposition ueber der Karte waehlt den Winkel: links die
        // Vorderansicht, nach rechts dreht sich das Teil weiter.
        karte.addEventListener('mousemove', function (e) {
          var k = karte.getBoundingClientRect();
          if (!k.width) return;
          var anteil = (e.clientX - k.left) / k.width;
          var i = Math.floor(anteil * anzahl);
          if (i < 0) i = 0;
          if (i > anzahl - 1) i = anzahl - 1;
          zeige(i);
        });
        karte.addEventListener('mouseleave', function () { zeige(0); });
      } else {
        // Am Handy gibt es keine Mausposition. Draufhalten blaettert selbst
        // weiter, Loslassen geht zurueck. Kein preventDefault, damit ein
        // kurzer Tipp weiterhin das Produkt oeffnet.
        var uhr = null;
        karte.addEventListener('touchstart', function () {
          karte.classList.add('is-peek');
          var i = 0;
          uhr = setInterval(function () {
            i = (i + 1) % anzahl;
            zeige(i);
          }, 650);
        }, { passive: true });

        function stopp() {
          if (uhr) { clearInterval(uhr); uhr = null; }
          karte.classList.remove('is-peek');
          zeige(0);
        }
        karte.addEventListener('touchend', stopp, { passive: true });
        karte.addEventListener('touchcancel', stopp, { passive: true });
      }

      zeige(0);
    });
  }

  /* ---------- Bildstrecke ganz oben ---------- */

  function initHeroSlides() {
    $$('[data-slides]').forEach(function (strecke) {
      var folien = $$('.hero-slides__slide', strecke);
      if (folien.length < 2) return;
      var punkte = $$('.hero-slides__dot', strecke);
      var jetzt = 0;
      var uhr = null;

      var takt = parseInt(strecke.getAttribute('data-autoplay'), 10);
      if (isNaN(takt)) takt = 5;

      function zeige(i) {
        if (i < 0) i = folien.length - 1;
        if (i >= folien.length) i = 0;
        jetzt = i;
        folien.forEach(function (f, n) { f.classList.toggle('is-on', n === i); });
        punkte.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
      }

      function starte() {
        if (takt <= 0 || reduceMotion) return;
        stoppe();
        uhr = setInterval(function () { zeige(jetzt + 1); }, takt * 1000);
      }
      function stoppe() {
        if (uhr) { clearInterval(uhr); uhr = null; }
      }
      // Nach einem Klick kurz warten, damit nicht gleich weitergeblaettert wird.
      function vonHand(i) { zeige(i); starte(); }

      var zurueck = $('[data-slide-prev]', strecke);
      var weiter = $('[data-slide-next]', strecke);
      if (zurueck) zurueck.addEventListener('click', function () { vonHand(jetzt - 1); });
      if (weiter) weiter.addEventListener('click', function () { vonHand(jetzt + 1); });
      punkte.forEach(function (p, n) {
        p.addEventListener('click', function () { vonHand(n); });
      });

      // BEWUSST KEIN Anhalten beim Drueberfahren.
      //
      // Die Bildstrecke ist 90vh hoch und steht ganz oben - der Mauszeiger
      // liegt beim Laden praktisch immer darueber. Mit "mouseenter stoppt"
      // blieb sie deshalb dauerhaft stehen und sprang erst weiter, sobald man
      // scrollte und der Zeiger die Flaeche verliess. Von aussen sah das aus,
      // als wuerde sie erst durch Scrollen ausgeloest.
      //
      // Angehalten wird nur noch dort, wo es wirklich noetig ist: im
      // Hintergrund-Tab und waehrend eines Wischers.

      // Im Hintergrund nicht weiterlaufen lassen.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stoppe(); else starte();
      });

      // Wischen am Handy.
      var startX = null;
      strecke.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
        stoppe();
      }, { passive: true });
      strecke.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var weg = e.changedTouches[0].clientX - startX;
        if (Math.abs(weg) > 45) zeige(weg < 0 ? jetzt + 1 : jetzt - 1);
        startX = null;
        starte();
      }, { passive: true });

      starte();
    });
  }

  /* ---------- Produktgalerie zum Wischen ---------- */

  function initProductGallery() {
    $$('[data-gallery]').forEach(function (rahmen) {
      if (rahmen.dataset.bereit === '1') return;
      rahmen.dataset.bereit = '1';

      var bahn = $('[data-gallery-track]', rahmen);
      if (!bahn) return;
      if ($$('.product__gallery-item', bahn).length < 2) return;
      var zurueck = $('[data-gallery-prev]', rahmen);
      var weiter = $('[data-gallery-next]', rahmen);

      // Bilder und Punkte werden bei JEDEM Aufruf frisch gelesen und auf die
      // sichtbaren gefiltert, statt sie einmal zu merken. Grund: der
      // Model/Produkt-Umschalter (assets/merken.js) blendet die halbe
      // Galerie per CSS aus - mit einer gemerkten Liste haette der Zaehler
      // weiter "3 / 5" gezeigt und die Pfeile waeren ins Leere gesprungen.
      function sichtbar(el) { return el.offsetParent !== null; }
      function bilderJetzt() { return $$('.product__gallery-item', bahn).filter(sichtbar); }
      function punkteJetzt() { return $$('.product__gallery-dot', rahmen).filter(sichtbar); }

      // Das Wischen und Einrasten macht der Browser (scroll-snap). Hier wird
      // nur gelesen, wo er gerade steht, und per Pfeil nachgeholfen.
      function jetzt(bilder) {
        var mitte = bahn.scrollLeft + bahn.clientWidth / 2;
        var beste = 0;
        var kleinster = Infinity;
        bilder.forEach(function (b, n) {
          var d = Math.abs(b.offsetLeft + b.offsetWidth / 2 - mitte);
          if (d < kleinster) { kleinster = d; beste = n; }
        });
        return beste;
      }

      // Zaehler wie bei Kith ("Slide 1 of 6") und Represent ("1 / 10"):
      // zeigt, dass es ueberhaupt mehr zu sehen gibt. Die Punkte allein
      // verraten das bei vielen Bildern schlecht.
      var zaehler = $('[data-gallery-count]', rahmen);

      function male() {
        var bilder = bilderJetzt();
        if (!bilder.length) return;
        var i = jetzt(bilder);
        var punkte = punkteJetzt();
        punkte.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
        if (zurueck) zurueck.disabled = i === 0;
        if (weiter) weiter.disabled = i === bilder.length - 1;
        if (zaehler) zaehler.textContent = (i + 1) + ' / ' + bilder.length;
      }

      function springe(schritt) {
        var bilder = bilderJetzt();
        if (!bilder.length) return;
        var i = jetzt(bilder) + schritt;
        if (i < 0) i = 0;
        if (i > bilder.length - 1) i = bilder.length - 1;
        bahn.scrollTo({ left: bilder[i].offsetLeft, behavior: 'smooth' });
      }

      if (zurueck) zurueck.addEventListener('click', function () { springe(-1); });
      if (weiter) weiter.addEventListener('click', function () { springe(1); });

      // Gedrosselt ueber die Uhr, nicht ueber requestAnimationFrame: in einem
      // Tab, der nicht zeichnet, laeuft kein Frame - die Punkte wuerden dann
      // auf einem alten Stand stehen bleiben.
      var zuletzt = 0;
      bahn.addEventListener('scroll', function () {
        var t = Date.now();
        if (t - zuletzt < 90) return;
        zuletzt = t;
        male();
      }, { passive: true });

      // Der Umschalter meldet sich hier, wenn er die Gruppe gewechselt hat.
      rahmen.addEventListener('acid:gallery:refresh', male);

      window.addEventListener('resize', male);
      male();
    });
  }

  /* ---------- Anmeldefenster mit Rabatt ---------- */

  function initSignupPopup() {
    var fenster = $('[data-signup-popup]');
    if (!fenster) return;

    var schluessel = fenster.getAttribute('data-key') || 'arwo-signup';
    var wartezeit = parseInt(fenster.getAttribute('data-delay'), 10);
    if (isNaN(wartezeit)) wartezeit = 8;

    // Der Browser des Besuchers merkt sich, dass er es schon gesehen hat.
    // Faellt der Speicher aus (privates Fenster, gesperrte Seitendaten), soll
    // das Fenster trotzdem funktionieren - dann eben jedes Mal.
    function schonGesehen() {
      try { return localStorage.getItem(schluessel) === '1'; } catch (e) { return false; }
    }
    function merken() {
      try { localStorage.setItem(schluessel, '1'); } catch (e) { /* egal */ }
    }

    // Wer gerade erfolgreich eingetragen hat, soll es nie wieder sehen.
    // Wichtig: die Erfolgsmeldung steht seit der Klaviyo-Direktanmeldung
    // IMMER im Code (nur per "hidden" versteckt), damit JS sie sofort
    // einblenden kann. Ein reiner Vorhanden-Check wuerde das Popup also ab
    // sofort fuer jeden Aufruf als "schon erledigt" markieren - deshalb
    // zusaetzlich pruefen, ob sie gerade wirklich sichtbar ist.
    var erfolgsBlock = $('[data-klaviyo-success]', fenster);
    if (erfolgsBlock && !erfolgsBlock.hidden) { merken(); return; }
    if (schonGesehen()) return;

    var vorherAktiv = null;

    function auf() {
      if (!fenster.hidden) return;
      vorherAktiv = document.activeElement;
      fenster.hidden = false;
      // Bewusst NICHT ueber requestAnimationFrame: in einem Hintergrund-Tab
      // laeuft kein Frame, dann bliebe das Fenster durchsichtig liegen und
      // wuerde jeden Klick auf die Seite abfangen. Ein erzwungener Umbruch
      // reicht, damit die Einblendung trotzdem weich laeuft.
      void fenster.offsetHeight;
      fenster.classList.add('is-open');
      document.addEventListener('keydown', beiTaste);
      var ersterEintrag = $('.signup-popup__input', fenster);
      if (ersterEintrag) ersterEintrag.focus();
    }

    function zu() {
      fenster.classList.remove('is-open');
      merken();
      document.removeEventListener('keydown', beiTaste);
      setTimeout(function () { fenster.hidden = true; }, 450);
      if (vorherAktiv && vorherAktiv.focus) vorherAktiv.focus();
    }

    function beiTaste(e) {
      if (e.key === 'Escape') zu();
    }

    $$('[data-signup-close]', fenster).forEach(function (el) {
      el.addEventListener('click', zu);
    });

    setTimeout(auf, wartezeit * 1000);
  }

  /* ---------- Direkt-Anmeldung bei Klaviyo ----------
     Meldet Newsletter- und Popup-Formular direkt bei Klaviyo an, statt den
     Umweg ueber Shopifys eigene Bestaetigungsmail + Webhook-Sync zu nehmen.
     Der Umweg hatte im Test rund 25-30 Minuten gedauert, bis die 15-%-Mail
     kam - fuer einen Rabattcode, den jemand sofort einloesen will, zu lang.

     Die Email-Liste "Email List" (XXqALy) steht dafuer auf Single-Opt-in:
     Klaviyo setzt die Zustimmung beim Aufruf direkt auf "abonniert", ohne
     eine weitere Bestaetigungsmail abzuwarten. Die Willkommen-Mail mit dem
     Code lost trotzdem aus (Flow haengt am Abo-Ereignis) - der Code steht
     zusaetzlich sofort auf der Seite, damit niemand auf eine Mail warten
     muss, um zu bestellen.

     Ohne JavaScript laeuft das Formular unveraendert ueber Shopify weiter
     (langsamer, aber funktionierend) - siehe den form-Tag in den Sections.
  ---------- */

  /* Grosses Popup mit dem Code, direkt nachdem die Anmeldung durch ist.
     Die kleine Anzeige im Formular selbst reicht offenbar nicht - die
     Leute merken gar nicht, dass sie schon da ist. */
  var CodePopup = {
    el: null,

    build: function () {
      var box = document.createElement('div');
      box.className = 'klaviyo-code-popup';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.hidden = true;
      box.innerHTML =
        '<div class="klaviyo-code-popup__backdrop" data-klaviyo-popup-close></div>' +
        '<div class="klaviyo-code-popup__box">' +
        '<button type="button" class="klaviyo-code-popup__x" data-klaviyo-popup-close aria-label="Schließen">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<p class="klaviyo-code-popup__eyebrow">DEIN CODE</p>' +
        '<p class="klaviyo-code-popup__code" data-klaviyo-popup-code></p>' +
        '<p class="klaviyo-code-popup__hint">Beim Bestellen eingeben und 15 % sparen.</p>' +
        '</div>';
      document.body.appendChild(box);
      var self = this;
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-klaviyo-popup-close]')) self.close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el && self.el.classList.contains('is-open')) self.close();
      });
      this.el = box;
    },

    open: function (code) {
      if (!code) return;
      if (!this.el) this.build();
      this.el.querySelector('[data-klaviyo-popup-code]').textContent = code;
      this.el.hidden = false;
      void this.el.offsetWidth;
      this.el.classList.add('is-open');
      scrollLock.lock();
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      scrollLock.unlock();
      var el = this.el;
      setTimeout(function () { el.hidden = true; }, reduceMotion ? 10 : 400);
    }
  };

  /* Rueckkehr von der Willkommen-Mail: der Knopf dort haengt
     "?klaviyo_code=1" an die Startseite an. Erst DANN geht das grosse
     Popup auf - absichtlich so gewuenscht, statt den Code gleich beim
     Eintragen zu zeigen. Die Quelle fuer den Codetext ist das (ueberall
     im Footer vorhandene, aber per JS versteckte) [data-klaviyo-code]. */
  function initKlaviyoCodeRueckkehr() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('klaviyo_code') !== '1') return;
    var quelle = $('[data-klaviyo-code]');
    var code = quelle ? quelle.textContent.trim() : '';
    if (code) CodePopup.open(code);
    url.searchParams.delete('klaviyo_code');
    if (history.replaceState) history.replaceState({}, '', url.toString());
  }

  function initKlaviyoSignup() {
    var COMPANY_ID = 'UvskgW';
    var LIST_ID = 'XXqALy';
    var API_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
    var EVENT_URL = 'https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID;
    var API_REVISION = '2024-10-15';
    var EVENT_NAME = 'Newsletter Anmeldung';
    var SPEICHER_MINUTEN = 10;

    function zeigeErfolg(form) {
      var felder = $('[data-klaviyo-fields]', form);
      var erfolg = $('[data-klaviyo-success]', form);
      if (felder) felder.hidden = true;
      if (erfolg) erfolg.hidden = false;
    }

    function merkeErfolg(form) {
      try { sessionStorage.setItem('arwo-klaviyo-' + form.id, String(Date.now())); } catch (e) { /* egal */ }
    }

    // Ueberlebt ein Reload (z.B. durch eine doppelte Absendung) - der Code
    // bleibt dann sichtbar, statt nach ein paar Sekunden zu verschwinden.
    function warSchonErfolgreich(form) {
      try {
        var wert = sessionStorage.getItem('arwo-klaviyo-' + form.id);
        if (!wert) return false;
        return (Date.now() - Number(wert)) < SPEICHER_MINUTEN * 60 * 1000;
      } catch (e) {
        return false;
      }
    }

    /* Eigenes Ereignis bei JEDER Anmeldung.
       Der Grund: Die Willkommen-Strecke haengt an Klaviyos Ereignis
       "Subscribed to Email Marketing". Das entsteht nur, wenn sich die
       Zustimmung tatsaechlich AENDERT - wer schon auf der Liste steht und
       sich nochmal eintraegt, loest gar nichts aus und bekommt deshalb
       keine zweite Mail. Wer die erste uebersehen hat, steht dann im
       Regen.

       Dieses Ereignis hier schickt die Seite selbst, bei jeder erfolgreichen
       Absendung, unabhaengig davon ob die Person neu ist. Haengt die
       Willkommen-Strecke daran statt am Zustimmungs-Ereignis, kommt die Mail
       jedes Mal. Die Umstellung dafuer passiert in Klaviyo (Ausloeser,
       Wiedereintritt, Smart Sending) - siehe Arbeitsstand.

       Absichtlich NACH der Anmeldung abgeschickt: kaeme das Ereignis zuerst,
       koennte Klaviyo die Mail verwerfen, weil die Zustimmung noch nicht
       verbucht ist. Faellt der Aufruf aus, bleibt die Anmeldung selbst davon
       unberuehrt - deshalb ohne eigene Fehlermeldung. */
    function ereignisMelden(emailWert, vorname, quelle) {
      var profilAttribute = { email: emailWert };
      if (vorname) profilAttribute.first_name = vorname;

      return fetch(EVENT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: API_REVISION },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { quelle: quelle },
              metric: { data: { type: 'metric', attributes: { name: EVENT_NAME } } },
              profile: { data: { type: 'profile', attributes: profilAttribute } }
            }
          }
        })
      }).catch(function () { /* still, die Anmeldung zaehlt */ });
    }

    function melde(form) {
      var email = $('input[type="email"]', form);
      var name = $('input[name="contact[first_name]"]', form);
      var fehler = $('[data-klaviyo-error]', form);
      var knopf = $('button[type="submit"]', form);
      if (!email || !email.value) return;

      if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
      var textVorher = knopf ? knopf.textContent : '';
      if (knopf) { knopf.disabled = true; }

      var profilAttribute = { email: email.value };
      if (name && name.value) profilAttribute.first_name = name.value;

      var nutzlast = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.id,
            profile: { data: { type: 'profile', attributes: profilAttribute } }
          },
          relationships: {
            list: { data: { type: 'list', id: LIST_ID } }
          }
        }
      };

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: API_REVISION },
        body: JSON.stringify(nutzlast)
      })
        .then(function (r) {
          // Klaviyos Client-API antwortet absichtlich knapp (202, kein Body) -
          // das ist bei dieser Schnittstelle der normale Erfolgsfall, kein
          // Sonderfall. Nur ein harter Fehlercode zaehlt als Fehlschlag.
          if (!r.ok && r.status !== 202) throw new Error('status ' + r.status);
          zeigeErfolg(form);
          merkeErfolg(form);
          ereignisMelden(email.value, name && name.value, form.id);

          // War es das Popup, soll es sich wie bei einer echten Bestaetigung
          // merken, dass diese Person es nicht wieder sehen muss.
          var fenster = form.closest('[data-signup-popup]');
          if (fenster) {
            var schluessel = fenster.getAttribute('data-key');
            if (schluessel) { try { localStorage.setItem(schluessel, '1'); } catch (e) { /* egal */ } }
          }
        })
        .catch(function () {
          if (fehler) {
            fehler.textContent = (ACID.strings && ACID.strings.newsletterError) || 'Das hat gerade nicht geklappt. Versuch es nochmal.';
            fehler.hidden = false;
          }
        })
        .then(function () {
          if (knopf) { knopf.disabled = false; knopf.textContent = textVorher; }
        });
    }

    // Beide Formulare stehen auf derselben Seite. Ohne diese Sperre ginge
    // das Popup zweimal auf, wenn Shopify beide als bestaetigt ausliefert.
    var bestaetigungGezeigt = false;

    ['NewsletterForm', 'SignupPopupForm'].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;

      // Merker, damit ein zweiter Aufruf nicht noch einen Zuhoerer anhaengt
      // (das wuerde jede Anmeldung doppelt abschicken). Erst dadurch darf
      // diese Funktion weiter unten sicherheitshalber nochmal laufen.
      if (form.dataset.klaviyoBereit === '1') return;
      form.dataset.klaviyoBereit = '1';

      // Hat SHOPIFY die Anmeldung gerade bestaetigt, hat Liquid die
      // Erfolgsmeldung samt Code schon serverseitig aufgedeckt (siehe
      // sections/newsletter.liquid: form.posted_successfully?). Das ist die
      // Seite "Vielen Dank, dass du dich fuer unsere Mailingliste
      // angemeldet hast", auf der jemand landet, nachdem er in Shopifys
      // Bestaetigungsmail auf "Abonnieren" geklickt hat.
      //
      // Genau dort hat diese Funktion den Code bisher wieder VERSTECKT -
      // die Zeile unten lief ohne Unterscheidung. Ergebnis: bestaetigt, aber
      // nirgendwo ein Code. Deshalb wird jetzt unterschieden:
      //   - serverseitig aufgedeckt  = Shopify hat bestaetigt -> Code zeigen
      //     und zusaetzlich das grosse Popup oeffnen, damit es niemand
      //     uebersieht;
      //   - sonst (Klaviyo-Direktanmeldung) -> verstecken, der Code kommt
      //     erst nach dem Klick in der Willkommensmail.
      var codeEl = $('[data-klaviyo-code]', form);
      var erfolgsBlock = $('[data-klaviyo-success]', form);
      var vonShopifyBestaetigt = !!erfolgsBlock && !erfolgsBlock.hidden;

      if (codeEl && !vonShopifyBestaetigt) codeEl.hidden = true;

      if (vonShopifyBestaetigt && !bestaetigungGezeigt) {
        bestaetigungGezeigt = true;
        CodePopup.open(codeEl ? codeEl.textContent.trim() : '');
      }

      if (warSchonErfolgreich(form)) zeigeErfolg(form);

      form.addEventListener('submit', function (e) {
        // preventDefault steht bewusst als Erstes, noch vor jeder Pruefung -
        // so kann nie eine native Shopify-Absendung nebenher durchrutschen
        // (das fuehrte vorher zu einer doppelten Anmeldung samt Reload).
        e.preventDefault();
        var email = $('input[type="email"]', form);
        if (email && !email.checkValidity()) {
          email.reportValidity();
          return;
        }
        melde(form);
      });
    });
  
    /* ---------- Vormerken auf der Produktseite -> Klaviyo (03.11.2026) ----------
       Das Vormerk-Formular geht wie bisher an Shopify (Kundentag mit Groesse,
       kein preventDefault). Zusaetzlich gehen beim Absenden drei Aufrufe an
       Klaviyo raus (keepalive, damit sie den Seitenwechsel ueberleben):
       1. Anmeldung auf der Liste,
       2. Ereignis "Vormerkung" mit Produkt + Groesse -> Flow
          "Vormerk-Bestaetigung" schickt sofort eine Mail mit Groesse + Code.
          Bewusst NICHT "Newsletter Anmeldung": der Code-Flow der Startseite
          hat eine 1-Stunden-Sperre, beide sollen sich nicht gegenseitig
          blockieren.
       3. Back-in-Stock-Abo fuer genau diese Variante -> Flow "Deine Groesse
          ist da" meldet sich automatisch, sobald Bestand eingebucht wird. */
    Array.prototype.forEach.call(document.querySelectorAll('form.product__notify-form'), function (form) {
      if (form.dataset.klaviyoBereit === '1') return;
      form.dataset.klaviyoBereit = '1';

      form.addEventListener('submit', function () {
        var email = $('input[type="email"]', form);
        if (!email || !email.value || !email.checkValidity()) return;
        var kopf = { 'Content-Type': 'application/json', revision: API_REVISION };
        var profil = { data: { type: 'profile', attributes: { email: email.value } } };
        var tagFeld = $('[data-notify-tags]', form);
        var groesse = (((tagFeld && tagFeld.value) || '').match(/groesse-([^,]+)/) || [])[1] || '';
        var produkt = ($('meta[property="og:title"]') || {}).content || document.title;
        var variantenFeld = $('form[action*="/cart/add"] [name="id"]');
        var variante = variantenFeld ? variantenFeld.value : '';
        var senden = function (url, nutzlast) {
          return fetch(url, { method: 'POST', keepalive: true, headers: kopf, body: JSON.stringify(nutzlast) })
            .catch(function () { /* Shopify-Absendung zaehlt trotzdem */ });
        };

        senden(API_URL, {
          data: {
            type: 'subscription',
            attributes: { custom_source: 'Vormerken Produktseite', profile: profil },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } }
          }
        });

        senden(EVENT_URL, {
          data: {
            type: 'event',
            attributes: {
              properties: { quelle: 'Vormerken', produkt: produkt, groesse: groesse, url: location.origin + location.pathname, variante: variante },
              metric: { data: { type: 'metric', attributes: { name: 'Vormerkung' } } },
              profile: profil
            }
          }
        });

        if (variante) {
          senden('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
            data: {
              type: 'back-in-stock-subscription',
              attributes: { channels: ['EMAIL'], profile: profil },
              relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variante } } }
            }
          });
        }
      });
    });
}

  function initSearch() {
    var overlay = $('[data-search-overlay]');
    if (!overlay) return;
    var input = $('[data-search-input]', overlay);
    var results = $('[data-search-results]', overlay);
    if (!input || !results) return;

    var run = debounce(function (term) {
      if (term.length < 2) { results.innerHTML = ''; return; }
      var url = (routes.predictive_search_url || '/search/suggest') +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-predictive-results]');
          results.innerHTML = list ? list.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 260);

    input.addEventListener('input', function () { run(input.value.trim()); });
    document.addEventListener('acid:overlay:open', function (e) {
      if (e.detail.element === overlay) setTimeout(function () { input.focus(); }, 150);
    });
  }

  /* ---------- collection sort ---------- */

  function initCollectionTools() {
    var select = $('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- boot ---------- */

  /* Jede Init einzeln abgesichert.
     Vorher lief alles in einer Reihe: wirft EIN Teil einen Fehler - etwa
     weil ein Browser etwas nicht kennt -, bricht die ganze Kette ab und
     alles Nachfolgende startet nie. Getroffen hat es ausgerechnet
     initKlaviyoSignup, das fast am Ende steht: ohne das faengt niemand die
     Absendung ab, das Formular geht nativ an Shopify, und der Besucher
     bekommt Shopifys "Abonnieren"-Mail ohne jeden Rabattcode.
     Am 26.10. sind so zwei echte Anmeldungen gelaufen (Kundentags
     "newsletter" bzw. "newsletter,popup" - die entstehen nur beim nativen
     Weg).
     Jetzt kostet ein Fehler nur noch seine eigene Funktion. */
  function sicher(name, fn) {
    try {
      fn();
    } catch (e) {
      if (window.console && console.error) console.error('[ARWO] ' + name + ':', e);
    }
  }

  function boot() {
    sicher('Overlay', function () { Overlay.init(); });
    sicher('Header', initHeader);
    sicher('Triggers', initTriggers);
    sicher('CartEvents', initCartEvents);
    sicher('ProductForms', initProductForms);
    sicher('VariantPickers', function () { initVariantPickers(); });
    sicher('QuickAdd', initQuickAdd);
    sicher('Reveal', initReveal);
    sicher('Parallax', initParallax);
    sicher('StickyAtc', initStickyAtc);
    sicher('Carousels', initCarousels);
    sicher('Lightbox', initLightbox);
    sicher('Search', initSearch);
    sicher('CollectionTools', initCollectionTools);
    sicher('FitText', initFitText);
    sicher('Rotators', initRotators);
    sicher('Sliders', initSliders);
    sicher('CardPeek', initCardPeek);
    sicher('CardAngles', initCardAngles);
    sicher('HeroSlides', initHeroSlides);
    sicher('ProductGallery', initProductGallery);
    sicher('SignupPopup', initSignupPopup);
    sicher('KlaviyoSignup', initKlaviyoSignup);
    sicher('KlaviyoCodeRueckkehr', initKlaviyoCodeRueckkehr);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Sicherheitsnetz fuer die Newsletter-Anmeldung: Sie ist der einzige Teil,
  // dessen Ausfall den Besucher auf den falschen Weg schickt (Shopify statt
  // Klaviyo, Bestaetigungsmail ohne Code). Deshalb nach dem vollstaendigen
  // Laden noch ein zweiter Anlauf. Dank des Merkers am Formular passiert
  // nichts doppelt, wenn der erste Anlauf geklappt hat.
  window.addEventListener('load', function () {
    sicher('KlaviyoSignup (zweiter Anlauf)', initKlaviyoSignup);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () {
    initVariantPickers();
    initReveal();
    initCarousels();
    initHeader();
    initParallax();
    initStickyAtc();
    initFitText();
    initRotators();
    initSliders();
    initCardPeek();
    initCardAngles();
    initHeroSlides();
    initProductGallery();
    initSignupPopup();
    initKlaviyoSignup();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id === 'shopify-section-cart-drawer') Cart.open();
  });

  document.addEventListener('acid:cart:updated', function () { initVariantPickers(); });

  window.ACIDTheme = { Cart: Cart, Overlay: Overlay, formatMoney: formatMoney };
})();
